import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_ModelRow,
    WB_Published_ModelRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbPublishedModel} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Model,
    esWB_Published_Model
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {} from "../PA.Model.Core/PA.Model.IF.Aspects";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ModelCoefficientSetBO} from "./ModelCoefficientSetBO";
import {
    IHaveModelCoefficientSet
} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects"
import {DateUtils} from "../PA.Core/Basic/Dates";
import {PartitionBO} from "../PA.MD.BusinessObjects/PartitionBO";
import {ModelingSessionBO} from "./ModelingSessionBO";

export class PublishedModelBO
    implements IBusinessObject,
        IHaveModelCoefficientSet {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Published_Model: WB_Published_ModelRow;

    modelingSessionBO: ModelingSessionBO

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Published Model'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);
        this.drWB_Published_Model = null;

        this.modelingSessionBO = undefined

        this.IHaveModelCoefficientSet_init()
    }

    get WB_PublishedModel(): WB_Published_ModelRow {
        return this.drWB_Published_Model;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Published Model");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            let wbModelId: number
            let wbSetID: number

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if ('WB_MODEL_COEFF_SET_ID' in self.LoadOptions)
                wbSetID = self.LoadOptions.WB_MODEL_COEFF_SET_ID;
            else {
                let sError = "Unable to determine Model Coefficient Set for new Published Model.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('WB_MODEL_ID' in self.LoadOptions)
                wbModelId = self.LoadOptions.WB_MODEL_ID;
            else {
                let sError = "Unable to determine Model for new Published Model.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Published Model.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let modelRow: WB_ModelRow = undefined
            // Create record using dbContext

            self.dbContext.find(esWB_Model, wbModelId)
                .then((aModelRecord: WB_ModelRow) => {
                    modelRow = aModelRecord

                    return self.dbContext.createRecordWithKey(esWB_Published_Model)
                })
                .then((newModelRow: WB_Published_ModelRow) => {
                    newModelRow.setDefaults();
                    self.drWB_Published_Model = newModelRow;
                    self.drWB_Published_Model.cif.WB_MODEL_COEFF_SET_ID = wbSetID
                    self.drWB_Published_Model.cif.WB_MODEL_ID = wbModelId
                    self.drWB_Published_Model.WB_ModelRow = modelRow
                    self.drWB_Published_Model.cif.PUBLISHED_MODEL_NAME = self.LoadOptions.PUBLISHED_MODEL_NAME
                    self.drWB_Published_Model.cif.PUBLISHED_MODEL_ID = self.LoadOptions.PUBLISHED_MODEL_NAME.replace(' ', '')
                    self.drWB_Published_Model.cif.PUBLISHED_MODEL_TYPE = self.LoadOptions.PUBLISHED_MODEL_TYPE
                    self.drWB_Published_Model.cif.EFFECTIVE_END_DT = self.LoadOptions.EFFECTIVE_END_DT
                    self.drWB_Published_Model.cif.EFFECTIVE_START_DT = self.LoadOptions.EFFECTIVE_START_DT
                    self.drWB_Published_Model.cif.COMMENTS = self.LoadOptions.COMMENTS
                    self.drWB_Published_Model.cif.WB_AUTHUSR_ID_CREATEDBY = usrContext.User.cif.WB_AUTHUSR_ID
                    self.drWB_Published_Model.WB_UserRow_CreatedBy = usrContext.User
                    self.drWB_Published_Model.cif.WB_MDSET_ID = self.LoadOptions.WB_MDSET_ID || 0
                    self.drWB_Published_Model.cif.WB_SALESORG_ID = self.LoadOptions.WB_SALESORG_ID || 0
                    self.drWB_Published_Model.cif.WB_ENTITY_ID_CUSTOMER =  self.LoadOptions.WB_ENTITY_ID_CUSTOMER || 0
                    self.drWB_Published_Model.cif.WB_ENTITY_ID_PRODUCT = self.LoadOptions.WB_ENTITY_ID_PRODUCT || 0
                    self.drWB_Published_Model.cif.WB_ENTITY_ID_PERIOD= self.LoadOptions.WB_ENTITY_ID_PERIOD || 0


                    self.Identity.setAll(self.WB_PublishedModel.cif.WB_PUBLISHED_MODEL_ID, self.WB_PublishedModel.cif.PUBLISHED_MODEL_ID, self.WB_PublishedModel.cif.PUBLISHED_MODEL_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_PublishedModel, 'WB_PUBLISHED_MODEL_ID', 'PUBLISHED_MODEL_ID', 'PUBLISHED_MODEL_NAME');

                    return self._AfterBoLoadCompleteInternal()
                })
                .then((ignore) => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");
        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "Model already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Published Model.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = PublishedModelBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = PublishedModelBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newModelRow: any = recordResolver.get(esWB_Published_Model, anId);

                    if (_.isEmpty(newModelRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Published_Model = newModelRow;
                    self.Identity.setAll(self.WB_PublishedModel.cif.WB_PUBLISHED_MODEL_ID, self.WB_PublishedModel.cif.PUBLISHED_MODEL_ID, self.WB_PublishedModel.cif.PUBLISHED_MODEL_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_PublishedModel, 'WB_PUBLISHED_MODEL_ID', 'PUBLISHED_MODEL_ID', 'PUBLISHED_MODEL_NAME');
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((ignore) => {
                    return self.loadModelingSessionBO()
                })
                .then((modelingSessionBO: ModelingSessionBO) => {
                    this.modelingSessionBO = modelingSessionBO

                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            let tasks: Promise<any>[] = [];
            self.LoadProgressProvider.setProgressMessage('Model.PostLoad', 'Processing Loaded Data');
            tasks.push(self.OnIHaveModelCoefficientSetLoaded)

            Promise.all(tasks)
                .then(() => {
                    resolve();
                })
                .catch((err: any) => {
                    error(err);
                });
        })
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    get bIsProductGroup():boolean{
        return _.uniq(_.map(_.filter(this.ModelCoefficientSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRRows,aRow=>aRow.isActive), 'WB_PRDGRP_ID')).length>1
    }

    get bIsProduct():boolean{
        return _.uniq(_.map(_.filter(this.ModelCoefficientSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRRows,aRow=>aRow.isActive), 'WB_PROD_ID')).length>1
    }

    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_PublishedModel.cif.PUBLISHED_MODEL_NAME + "(" + self.WB_PublishedModel.cif.PUBLISHED_MODEL_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Published Model.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbModel = <IwbPublishedModel>self.drWB_Published_Model;
        this.SaveProgressProvider.start("Saving " + wbModel.PUBLISHED_MODEL_NAME + "(" + wbModel.PUBLISHED_MODEL_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Published Model.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};
            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }
           if(self.modelingSessionBO)
                self.drWB_Published_Model.cif.WB_SALESORG_ID = self.modelingSessionBO.WB_ModelingSession.cif.WB_SALESORG_ID
            else if(options?.WB_SALESORG_ID)
               self.drWB_Published_Model.cif.WB_SALESORG_ID = options.WB_SALESORG_ID
            saveFunction(esWB_Published_Model, self.drWB_Published_Model, {})
                .then((ignore) => {
                    var tasks: Promise<any>[] = [];
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    reject(self);
                })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbModel = <IwbPublishedModel>self.drWB_Published_Model;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbModel.PUBLISHED_MODEL_NAME + "(" + wbModel.PUBLISHED_MODEL_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Model

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Published_Model.markDeleted()

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    async UpdateCoefficientSet(wbModelingSessionId: number,
                               wbSourceSetId: number,
                               wbTrailId: number,
                               wbMDSetID?:number,
                               wbSalesOrgID?:number,
                               wbEntityId_Cust?:number,
                               wbEntityId_Prod?:number,
                               wbEntityId_Period?:number,
                               wbCustHId_DataSet?: number,
                               wbPrdHId_DataSet?: number,
                               wbPeriodHId_DataSet?: number): Promise<string> {
        const self = this
        try {
            await self.ModelCoefficientSet.UpdateCoefficientSet(self.ModelCoefficientSet, wbModelingSessionId, wbSourceSetId, wbTrailId, false)
            self.WB_PublishedModel.cif.MODIFIED_DTTS = DateUtils.convertToSAPBWTs(new Date())
            self.WB_PublishedModel.cif.WB_MDSET_ID= wbMDSetID
            self.WB_PublishedModel.cif. WB_SALESORG_ID= wbSalesOrgID
            self.WB_PublishedModel.cif.WB_ENTITY_ID_CUSTOMER= wbEntityId_Cust
            self.WB_PublishedModel.cif.WB_ENTITY_ID_PRODUCT= wbEntityId_Prod
            self.WB_PublishedModel.cif.WB_ENTITY_ID_PERIOD= wbEntityId_Period
            self.WB_PublishedModel.cif.WB_CUSTH_ID_DS = wbCustHId_DataSet
            self.WB_PublishedModel.cif.WB_PRDH_ID_DS = wbPrdHId_DataSet
            self.WB_PublishedModel.cif.WB_PERIODH_ID_DS = wbPeriodHId_DataSet
            await self.Save({})
            return "Updated Coefficient Set"
        } catch (err) {
            return err.toString()
        }

    }

    loadModelingSessionBO(): Promise<IBusinessObject> {
        return new Promise<IBusinessObject>((resolve, error) => {
            let self = this
            let modelingSessionId: number = self.WB_PublishedModel.WB_ModelCoeffSetRow.cif.WB_MODELING_SESSION_ID
            let modelingSessionBO = new ModelingSessionBO({dbContext: self.dbContext})

            modelingSessionBO.Load(modelingSessionId)
                .then((aModelingSessionBO: ModelingSessionBO) => {
                    resolve(aModelingSessionBO)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    //</editor-fold>


    //<editor-fold desc = "IModel">

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const model_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        };

        const aRecResolver = new ESRecordResolver(dbContext, model_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Published_Model, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

    private _modelCoefficientSet: ModelCoefficientSetBO;
    private _OnIHaveModelCoefficientSetLoaded: Promise<void>;
    private _bIHaveModelCoefficientSetLoaded: boolean;

    IHaveModelCoefficientSet_init() {
        this._bIHaveModelCoefficientSetLoaded = false
        this._OnIHaveModelCoefficientSetLoaded = undefined
        this._modelCoefficientSet = undefined
    }

    get bIHaveModelCoefficientSetLoaded(): boolean {
        return this._bIHaveModelCoefficientSetLoaded
    }

    get OnIHaveModelCoefficientSetLoaded(): Promise<void> {
        const self = this

        if (self._OnIHaveModelCoefficientSetLoaded)
            return self._OnIHaveModelCoefficientSetLoaded

        let returnValue = self._OnIHaveModelCoefficientSetLoaded = new Promise<void>((resolve, error) => {
            let wbModelCoefficientSetId = self.WB_PublishedModel.cif.WB_MODEL_COEFF_SET_ID
            if (!(wbModelCoefficientSetId > 0)) {
                error(`No Coeff Set Specified: ${wbModelCoefficientSetId}`)
                return
            }
            let aModelCoefficientSet = new ModelCoefficientSetBO()
            aModelCoefficientSet.Load(wbModelCoefficientSetId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._modelCoefficientSet = aModelCoefficientSet
                    self._bIHaveModelCoefficientSetLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return returnValue
    }

    get ModelCoefficientSet(): ModelCoefficientSetBO {
        return this._modelCoefficientSet
    }

//</editor-fold>
}

PAEnvironment.registerBusinessObjectClass(PublishedModelBO,"PublishedModelBO", "Published Model")